import { useEffect } from "react";
import { useCookieConsent } from "react-cookie-manager";

const GTM_ID = "GTM-NW7C3H3D";
const META_PIXEL_ID = "669596114632110";

export function TrackingManager() {
    const { detailedConsent } = useCookieConsent();

    const analyticsAllowed =
        detailedConsent?.Analytics?.consented ?? false;

    const advertisingAllowed =
        detailedConsent?.Advertising?.consented ?? false;

    // GTM načítame, ak používateľ povolil
    // analytické alebo marketingové cookies
    useEffect(() => {
        const shouldLoadGTM =
            analyticsAllowed || advertisingAllowed;

        if (!shouldLoadGTM) return;

        loadGTM();
    }, [analyticsAllowed, advertisingAllowed]);

    // Meta Pixel načítame iba pri marketingovom súhlase
    useEffect(() => {
        if (advertisingAllowed) {
            loadMetaPixel();
        } else {
            revokeMetaConsent();
        }
    }, [advertisingAllowed]);

    return null;
}

function loadGTM() {
    if (document.getElementById("google-tag-manager")) {
        return;
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
    });

    const script = document.createElement("script");

    script.id = "google-tag-manager";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;

    document.head.appendChild(script);
}

function loadMetaPixel() {
    // Pixel už bol inicializovaný
    if (window.fbq) {
        window.fbq("consent", "grant");
        return;
    }

    const fbq = function (...args) {
        if (fbq.callMethod) {
            fbq.callMethod(...args);
        } else {
            fbq.queue.push(args);
        }
    };

    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];

    window.fbq = fbq;
    window._fbq = fbq;

    // Defaultne bez súhlasu
    fbq("consent", "revoke");

    const script = document.createElement("script");

    script.id = "meta-pixel";
    script.async = true;
    script.src =
        "https://connect.facebook.net/en_US/fbevents.js";

    document.head.appendChild(script);

    fbq("init", META_PIXEL_ID);

    // Používateľ už marketing povolil
    fbq("consent", "grant");

    fbq("track", "PageView");
}

function revokeMetaConsent() {
    if (window.fbq) {
        window.fbq("consent", "revoke");
    }
}